export default "__VITE_ASSET__DRjSbc1o__"